import { useBundle } from '@amzn/react-arb-tools';

export function useTranslation(bundleName: string): (key: string, ...args: any[]) => string {
    const [bundle] = useBundle(bundleName);

    return (key: string, ...args: any[]) => {
        if (!bundle) return key;
        try {
            return args.length > 0
                ? bundle.formatMessage(key, ...args)
                : bundle.getMessage(key);
        } catch {
            return key;
        }
    };
}
